







































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
// import { onMounted, onUpdated, onUnmounted } from "@vue/composition-api";
import moment from "moment";
import echarts from "echarts";
// import echarts from "@/components/index.vue";
// import Echarts from "@/components/Echarts/index.vue";
import {
  gettrainManagelist,
  addTrain,
  traindetail,
  updateinfo,
  getorglist,
  gettrainlist,
  exportresult,
  downloadFile,
  traindetaillist,
} from "@/api/trainPlaneManage";
import Pagination from "@/components/Pagination/index.vue";
@Component({
  name: "equipManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  created() {
    this.getSession();
    console.log(this.userid);
  }
  mounted() {
    this.getlist(this.listQuery);
    this.getOrglist();
    // 防止浏览器后退
    history.pushState(null, "null", document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, "null", document.URL);
    });
  }
  private echarts = require("echarts");
  private isloading = true;
  private orglistArry: any = []; //组织列表
  private tablecoulunmn = true; //列动态显示和隐藏
  // private diashow = true;
  private uploadlist: any = []; // 已上传附件展示
  private fileisshow: any = false; //文件是否上传
  private userid = ""; //当前登录用户的userid
  private listQuery: any = {
    name: "",
    page: 1,
    limit: 10,
    isuse: 1,
    orgnizeid: "",
  };
  private options = [
    {
      key: "启用",
      value: 1,
    },
    {
      key: "禁用",
      value: 0,
    },
  ];
  private show() {
    (this.$parent as any).show();
  }
  private total: number = 0; //训练计划列表的total
  private trainTotal: number = 0; //训练进度列表的total
  private time: any = "";
  private xdata: any = []; //echarts横轴数据
  private xcountdata: any = [];
  private ydata: any = []; //echarts纵轴数据
  private title = "";
  private forwardparam = {
    forwardingregion: "", //转发的组织id
    forwardid: "", //转发数据的id
  };

  private isuse = 1;
  private showdisplay = "block";
  private trainListquery = {
    id: "",
    page: 1,
    limit: 10,
  };
  // 所有绑定数据源
  private allParams: any = {
    searchValue: "",
    dialogVisible: false,
    title: "",
    tarinPlaneVisible: false,
    echartsVisible: false,
    trainVisible: false,
    disibleState: false,
    closeable: true,
    listLoading: false,
    detailviesible: false,
    detailtitle: "", //详情标题
    detaildata: {}, //详情数据
    detailorglist: [],
    forwardvisible: false,
  };
  private multipleSelection: any = [];
  // 编辑的数据源
  private editform: any = {};
  // 添加的参数
  private dealForm: any = {
    orgnizeid: "",
    activitydescription: "",
    isuse: 0,
    endtime: "",
    begintime: "",
    trainname: "",
    region: "",
    userid: "",
    teacher: "",
    timeplace: "",
    traintime: "",
  };
  private uploadfile = [];
  private fileSizeIsSatisfy: any = [];
  // 训练计划表格数据
  private tableData = [];
  private trainPlaneData = [];
  private getSession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    this.dealForm.orgnizeid = parma.orgnizeid.split(",").pop();
    console.log(parma.orgnizeid.split(",").length);
    if (parma.orgnizeid.split(",").length === 3) {
      this.tablecoulunmn = false;
    }
    this.dealForm.userid = parma.userid;
    this.userid = parma.userid;
  }
  // 表格插槽点击方法
  private removeData(params: any) {
    this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
      const param = {
        id: params.id,
      };
      await traindetail(param).then(async (res) => {
        if (res.code === 200) {
          const isuse = params.isuse == true ? 1 : 0;
          const formData: any = new FormData();
          let resdata = res.data;
          formData.append("trainname", resdata.trainname);
          formData.append("begintime", resdata.begintime);
          formData.append("endtime", resdata.endtime);
          formData.append("isuse", isuse);
          formData.append("activitydescription", resdata.activitydescription);
          formData.append("orgnizeid", resdata.orgnizeid);
          formData.append("region", resdata.region);
          formData.append("timeplace", resdata.timeplace);
          formData.append("teacher", resdata.teacher);
          formData.append("userid", resdata.userid);
          formData.append("isdelete", 0);
          formData.append("id", resdata.id);
          await updateinfo(formData).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getlist(this.listQuery);
              this.editform = {};
            } else {
              this.$message({
                message: "删除失败",
                type: "warning",
              });
            }
          });
        }
      });
    });
  }

  private searchData() {
    this.getlist(this.listQuery);
  }
  // 展示详情
  private async showTrainDetial(value: any) {
    // this.emptyParams();
    this.showdisplay = "block";
    this.uploadlist = [];

    // this.diashow = true;
    const param = {
      id: value.id,
    };
    await traindetail(param).then((res) => {
      if (res.code === 200) {
        let resdata = res.data;
        let filename;
        let filepath;
        if (resdata.filePath !== null) {
          this.fileisshow = true;
          filename = resdata.fileName.split(",");
          filepath = resdata.filePath.split(",");
          for (let i in filename) {
            const arr = { name: filename[i], path: filepath[i] };
            this.uploadlist.push(arr);
          }
        } else {
          this.fileisshow = false;
        }
        this.dealForm.trainname = resdata.trainname;
        this.dealForm.isuse = resdata.isuse;
        this.dealForm.traintime = [
          new Date(resdata.begintime),
          new Date(resdata.endtime),
        ];
        this.dealForm.timeplace = resdata.timeplace;
        this.dealForm.teacher = resdata.teacher;
        this.dealForm.region = resdata.region.split(",");
        this.dealForm.orgnizeid = resdata.orgnizeid;
        this.dealForm.activitydescription = resdata.activitydescription;
        this.dealForm.activitydescription = resdata.activitydescription;
        this.dealForm.userid = resdata.userid;

        // this.dealForm = res.data
        // this.dealForm = res.data;
        this.editform.id = value.id;
      }
    });
    this.allParams.dialogVisible = true;
    this.allParams.disibleState = false;
    this.allParams.title = "编辑训练计划";
    // this.allParams.closeable = true;
  }
  private download(val) {
    console.log("下载训练计划")
    var ahref = document.createElement("a");
    let url = "./" + val.filepath + "";
    ahref.href = url;
    ahref.download = val.filename;
    ahref.click();
  }
  // 转发数据
  private forwarding(parms: any) {
    this.allParams.forwardvisible = true;
    this.forwardid = parms.id;
    this.$nextTick(() => {
      (this.$refs.forwardfrom as any).resetFields();
    });
  }
  // 提交转发数据
  private forwardingform() {
    let param = {
      id: this.forwardid,
    };
    (this.$refs.forwardfrom as any).validate(async (valid) => {
      if (valid === true) {
        await traindetail(param).then(async (res) => {
          if (res.code === 200) {
            const formData: any = new FormData();
            let resdata = res.data;
            formData.append("trainname", resdata.trainname);
            formData.append("begintime", resdata.begintime);
            formData.append("endtime", resdata.endtime);
            formData.append("isuse", resdata.isuse);
            formData.append("activitydescription", resdata.activitydescription);
            formData.append("orgnizeid", this.dealForm.orgnizeid);
            formData.append("region", this.forwardparam.forwardingregion);
            formData.append("timeplace", resdata.timeplace);
            formData.append("teacher", resdata.teacher);
            formData.append("userid", this.userid);
            await addTrain(formData).then((res: any) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "转发成功!",
                });
                this.editform = {};
                this.allParams.forwardvisible = false;
                this.getlist(this.listQuery);
              } else {
                this.$message({
                  message: "转发失败",
                  type: "warning",
                });
              }
            });
          }
        });
      }
    });
  }
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  // 导出成绩
  private async exportresult() {
    if (this.multipleSelection.length === 0) {
      this.$message.warning("请选择需要导出得数据");
    } else {
      let idlist: any = [];
      this.multipleSelection.forEach((item: any) => {
        idlist.push(item.id);
      });
      await exportresult(idlist).then((res) => {
        if (res.code === 200) {
        }
      });
    }
  }
  // 设置表格字体居中
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }

  //创建训练计划
  private async addTrain() {
    this.showdisplay = "block";
    // this.diashow = true;
    this.fileisshow = false;
    this.fileSizeIsSatisfy = [];
    this.time = [];
    this.allParams.dialogVisible = true;
    this.allParams.disibleState = false;
    this.allParams.title = "创建训练计划";
    this.$nextTick(() => {
      this.emptyParams();
      (this.$refs.dealForm as any).resetFields();
    });
  }
  // 获取添加训练计划的组织信息
  private async getOrglist() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    let orgparm = {
      organid: parma.orgnizeid.split(",").pop(),
    };
    await getorglist(orgparm).then((res) => {
      if (res.code === 200) {
        res.data.forEach((res) => {
          this.orglistArry.push({
            label: res.label,
            value: res.id,
          });
        });
      }
    });
  }

  // 文件上传方法
  private fileOnChange(file: any) {
    this.fileSizeIsSatisfy.push(file.raw);
    console.log(this.fileSizeIsSatisfy);
  }
  private handleExceed(file: any, fileList: any) {
    this.$message.warning(`当前限制上传 3 个文件`);
  }
  private fileBeforeRemove(file: any, fileList: any) {
    this.fileSizeIsSatisfy = fileList;
  }

  // 表单提交方法
  private saveForm() {
    const form = this.$refs.dealForm as any;
    this.dealForm.begintime = moment(this.dealForm.traintime[0]).format(
      "YYYY-MM-DD 00:00:00"
    );
    this.dealForm.endtime = moment(this.dealForm.traintime[1]).format(
      "YYYY-MM-DD 23:59:59"
    );
    // this.dealForm = {};
    this.dealForm.createtime = moment(Date.now()).format("YYYY-MM-DD HH:mm:ss");
    this.getSession();
    form.validate(async (valid: boolean) => {
      if (valid) {
        // 创建一个formData对象
        const formData: any = new FormData();
        console.log(this.editform.id);
        if (this.editform.id !== undefined) {
          for (var i = 0; i < this.fileSizeIsSatisfy.length; i++) {
            formData.append("file", this.fileSizeIsSatisfy[i]);
          }
          // 动态生成参数
          formData.append("trainname", this.dealForm.trainname);
          formData.append("begintime", this.dealForm.begintime);
          formData.append("endtime", this.dealForm.endtime);
          formData.append("isuse", this.dealForm.isuse);
          formData.append(
            "activitydescription",
            this.dealForm.activitydescription
          );
          formData.append("orgnizeid", this.dealForm.orgnizeid);
          formData.append("region", this.dealForm.region);
          formData.append("timeplace", this.dealForm.timeplace);
          formData.append("teacher", this.dealForm.teacher);
          formData.append("userid", this.dealForm.userid);
          formData.append("isdelete", 1);
          formData.append("id", this.editform.id);
          await updateinfo(formData).then((res) => {
            if (res.code === 200) {
              this.allParams.dialogVisible = false;
              this.dealForm = {};
              this.emptyParams();
              this.getlist(this.listQuery);
            }
          });
        } else {
          for (var i = 0; i < this.fileSizeIsSatisfy.length; i++) {
            formData.append("file", this.fileSizeIsSatisfy[i]);
          }
          // 动态生成参数
          formData.append("trainname", this.dealForm.trainname);
          formData.append("begintime", this.dealForm.begintime);
          formData.append("endtime", this.dealForm.endtime);
          formData.append("isuse", this.dealForm.isuse);
          formData.append(
            "activitydescription",
            this.dealForm.activitydescription
          );
          formData.append("orgnizeid", this.dealForm.orgnizeid);
          formData.append("region", this.dealForm.region);
          formData.append("timeplace", this.dealForm.timeplace);
          formData.append("teacher", this.dealForm.teacher);
          formData.append("userid", this.dealForm.userid);
          await addTrain(formData).then((res) => {
            if (res.code === 200) {
              this.allParams.dialogVisible = false;
              this.dealForm = {};
              this.emptyParams();
              this.getlist(this.listQuery);
            }
          });
        }
      } else {
        return false;
      }
    });
  }

  // 表单校验方法
  private rules = {
    timeplace: [{ required: true, message: "请输入地点", trigger: "blur" }],
    teacher: [{ required: true, message: "请输入授课人", trigger: "blur" }],
    trainname: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
    traintime: [{ required: true, message: "请选择时间", trigger: "change" }],
    region: [{ required: true, message: "请选择组织信息", trigger: "change" }],
    activitydescription: [
      { required: true, message: "请填写活动形式", trigger: "blur" },
    ],
  };

  // 模态框关闭方法
  private handleClose() {
    this.allParams.dialogVisible = false;

    (this.$refs.dealForm as any).resetFields();
  }
  private handclosedetai() {
    this.allParams.detailviesible = false;
  }
  // 关闭选择转发组织模态框
  private handcloseFord() {
    this.allParams.forwardvisible = false;
  }
  private saveOrginfo(parm: any) {
    this.dealForm.region = parm;
  }
  private async changeSwitch(parms: any) {
    console.log(parms);
    let param = {
      id: parms.id,
    };
    await traindetail(parms).then(async (res) => {
      if (res.code === 200) {
        const isuse = parms.isuse == true ? 1 : 0;
        const formData: any = new FormData();
        let resdata = res.data;
        formData.append("trainname", resdata.trainname);
        formData.append("begintime", resdata.begintime);
        formData.append("endtime", resdata.endtime);
        formData.append("isuse", isuse);
        formData.append("activitydescription", resdata.activitydescription);
        formData.append("orgnizeid", resdata.orgnizeid);
        formData.append("region", resdata.region);
        formData.append("timeplace", resdata.timeplace);
        formData.append("teacher", resdata.teacher);
        formData.append("userid", resdata.userid);
        formData.append("isdelete", 1);
        formData.append("id", resdata.id);
        await updateinfo(formData).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "状态更改成功!",
            });
            this.editform = {};
            this.getlist(this.listQuery);
          } else {
            this.$message({
              message: "更改失败",
              type: "warning",
            });
          }
        });
      }
    });
  }
  // 显示训练进度模态框
  private async showTarinPlane(parm: any) {
    this.allParams.tarinPlaneVisible = true;
    // this.trainListquery.id = "123";
    this.trainListquery.id = parm.id;
    this.getTrainlist(this.trainListquery);
  }
  private async getTrainlist(param) {
    await gettrainlist(param).then((res) => {
      if (res.code === 200) {
        this.trainPlaneData = res.data.items;
        this.trainTotal = res.data.total;
      }
    });
  }
  private handleTrain() {
    this.allParams.tarinPlaneVisible = false;
  }
  // 显示训练计划详情
  private async watchTrainDetail(row: any) {
    // this.allParams.disibleState = true;
    // this.showdisplay = "none";
    // this.uploadlist = [];
    // this.fileisshow = true;
    // this.diashow = false;
    // this.allParams.closeable = false;
    this.allParams.detailorglist = [];
    this.allParams.detailviesible = true;
    this.allParams.detailtitle = row.trainname + "详情";
    const param = {
      id: row.id,
    };
    const array: any = [];
    await traindetaillist(param).then((res) => {
      if (res.code === 200) {
        let filepath;
        let filename;
        console.log(res.data.filePath !== null);
        if (res.data.filePath !== null) {
          filepath = res.data.filePath.split(",");
          filename = res.data.fileName.split(",");
          for (let i in filepath) {
            this.allParams.detailorglist.push({
              path: filepath[i],
              name: filename[i],
            });
          }
          this.allParams.detaildata = res.data;
        } else {
          // this.allParams.detailorglist = [];
          this.allParams.detaildata = res.data;
        }
      } else {
        this.$message.warning("数据查询错误");
      }
    });
  }
  private handleTrainClose() {
    this.allParams.trainVisible = false;
  }
  private showTrainEcharts(row: any, type: any) {
    if (type === "trainlong") {
      this.title = "训练时长分布图";
      if (row.trainlength.length != 0) {
        row.trainlength.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前训练时长没有数据",
        });
      }
    } else if (type === "traintime") {
      this.title = "训练次数分布图";
      if (row.trainnumber.length != 0) {
        row.trainnumber.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前训练次数没有数据",
        });
      }
    } else if (type === "lerantime") {
      this.title = "理论学习时长分布图";
      if (row.trainnumber.length != 0) {
        row.learnhoureh.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前理论学习时长没有数据",
        });
      }
    } else if (type === "learnpersontime") {
      this.title = "理论学习人次数分布图";
      if (row.learnpersontimeeh.length != 0) {
        row.trainnumber.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前训练次数没有数据",
        });
      }
    } else if (type === "exampersontime") {
      this.title = "考核人次数分布图";
      if (row.trainnumber.length != 0) {
        row.exampersontimeeh.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前训练次数没有数据",
        });
      }
    } else if (type === "examtime") {
      this.title = "考核次数分布图";
      if (row.trainnumber.length != 0) {
        row.examtimeeh.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前训练次数没有数据",
        });
      }
    } else if (type === "examresult") {
      this.title = "考核成绩分布图";
      if (row.examresulteh.length != 0) {
        row.trainnumber.forEach((ele: any) => {
          this.xdata.push(ele.xdata.substring(0, 10));
          this.ydata.push(ele.ydata);
        });
      } else {
        this.$message({
          type: "warning",
          message: "当前训练次数没有数据",
        });
      }
    }
    this.allParams.echartsVisible = true;
  }
  private closeEcharts() {
    this.allParams.echartsVisible = false;
    this.xdata = [];
    this.ydata = [];
    this.title = "";
  }
  private async showTrainName(parm: any) {
    this.allParams.trainVisible = true;
    this.trainListquery.id = parm.id;
    await gettrainlist(this.trainListquery).then((res) => {
      if (res.code === 200) {
        this.trainPlaneData = res.data.items;
        this.trainTotal = res.data.total;
      }
    });
  }
  // 绑定echarts
  private drawEcharts(xdata: any, ydata: any, title: any) {
    let mychart = this.$echarts.init(this.$refs.bar_dv);
    // 绘制图表
    mychart.setOption({
      tooltip: {
        trigger: "axis",
        formatter: "{b} : {c}",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "none", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      title: {
        // text: title,
        top: 20,
        left: 18,
        textStyle: {
          color: "#333333",
          fontSize: 16,
        },
      },
      toolbox: {
        show: true,
        feature: {
          mark: { show: true },
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ["line", "bar"] },
          restore: { show: true },
          saveAsImage: { show: true },
        },
      },
      calculable: true,
      legend: {
        data: ["Growth", title],
        itemGap: 5,
      },
      grid: {
        top: 70,
        left: "5%",
        right: "10%",
        containLabel: true,
      },
      // xAxis: [
      //   {
      //     data: xdata,
      //     name: "时间",
      //     axisLine: {
      //       symbol: ["none", "arrow"],
      //     },
      //   },
      // ],
      xAxis: {
        type: "category",
        data: xdata,
        name: "组织名称",
        left: "5%",
        axisLine: {
          show: true,
          // symbolSize: (100, 8),
          symbol: ["none", "arrow"],
          lineStyle: {
            color: "#969A9F",
          },
        },

        offset: 20,
        axisTick: {
          show: false,
          length: 9,
          alignWithLabel: true,
          lineStyle: {
            color: "#969A9F",
          },
        },
        axisLabel: {
          fontSize: 10,
        },
      },
      yAxis: {
        type: "value",
        name: "时长",
        axisLine: {
          show: true,
          // symbolSize: (100, 8),
          symbol: ["none", "arrow"],
          lineStyle: {
            color: "#969A9F",
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 16,
        },
        boundaryGap: ["0%", "15%"],
      },
      dataZoom: [
        {
          show: true,
          start: 0,
          end: 50,
        },
        {
          type: "inside",
          start: 0,
          end: 50,
        },
        // {
        //   show: true,
        //   // yAxisIndex: 0,
        //   filterMode: "empty",
        //   width: 30,
        //   height: "80%",
        //   showDataShadow: false,
        //   left: "93%",
        // },
      ],
      series: [
        {
          name: title,
          type: "bar",
          barWidth: 40,
          data: ydata,
          color: "#32D3EB",
          emphasis: {
            label: {
              show: false,
            },
          },
        },
        // {
        //   name: "次数分布图",
        //   type: "bar",
        //   data: xcountdata,
        //   color: "#32D3EB",
        // },
      ],
    });
  }
  private open() {
    if (this.xdata.length != 0) {
      this.$nextTick(() => {
        //  执行echarts方法
        this.drawEcharts(this.xdata, this.ydata, this.title);
        // this.drawEcharts(this.xdata, this.ydata, this.title);
      });
    }
  }
  //获取列表
  private async getlist(parm: any) {
    this.listLoading = true;
    let parmitem = sessionStorage.getItem("json");
    let parma: any = null;
    if (parmitem != null) {
      parma = JSON.parse(parmitem);
    }
    this.listQuery.orgnizeid = parma.orgnizeid.split(",").pop();
    await gettrainManagelist(this.listQuery)
      .then((res) => {
        if (res.code === 200) {
          this.isloading = false;
          res.data.items.forEach((item: any) => {
            item.isuse = item.isuse == 1 ? true : false;
          });

          this.tableData = res.data.items;
          this.allParams.listLoading = false;
          this.total = res.data.total;
        } else {
          this.isloading = false;
          this.$message({
            type: "warning",
            message: "获取数据失败",
          });
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      });
  }
  private pickerOptionsStart() {
    const time: any = "";
    let beginDateVal = this.dealForm.begintime;
    if (beginDateVal) {
      return time.getTime() > new Date(beginDateVal).getTime();
    }
  }
  private pickerOptionsEnd() {
    const time: any = "";
    let endDateVal = this.dealForm.endtime;
    if (endDateVal) {
      return time.getTime() < new Date(this.startTime).getTime() - 86400000;
    }
  }
  private clearSearch() {
    this.listQuery.name = "";
    this.getlist(this.listQuery);
  }
  // 训练进度列表分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getlist(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getlist(this.listQuery);
  }
  private handleSizeChangetrain(val: number) {
    this.trainListquery.page = val;
    this.getTrainlist(this.trainListquery);
  }
  private handleCurrentChangetrain(val: number) {
    this.trainListquery.page = val;
    this.getTrainlist(this.trainListquery);
  }
  private emptyParams() {
    this.dealForm = {
      orgnizeid: "",
      activitydescription: "",
      isuse: 0,
      endtime: "",
      begintime: "",
      trainname: "",
      region: "",
      userid: "",
      teacher: "",
      timeplace: "",
      traintime: "",
    };
    this.editform = {};
    this.fileSizeIsSatisfy = [];
  }
}
